import CrudPage from "@/components/CrudPage";
import { useAuth, canWrite } from "@/context/AuthContext";
import { rupiah } from "@/lib/format";

export default function MasterOverhead() {
  const { user } = useAuth();
  const writeRoles = ["akuntansi"];
  return (
    <CrudPage
      title="Master Overhead"
      subtitle="Komponen biaya overhead pabrik (BOP)."
      endpoint="/overhead-items"
      canWrite={canWrite(user?.role, writeRoles)}
      searchKeys={["code", "name", "jenis"]}
      columns={[
        { key: "code", label: "Kode" },
        { key: "name", label: "Nama Overhead" },
        { key: "jenis", label: "Jenis", render: (r) => <span className="capitalize">{r.jenis}</span> },
        { key: "satuan", label: "Satuan" },
        { key: "tarif", label: "Tarif", align: "right", render: (r) => rupiah(r.tarif) },
        { key: "keterangan", label: "Keterangan" },
      ]}
      fields={[
        { key: "code", label: "Kode Overhead" },
        { key: "name", label: "Nama Overhead" },
        { key: "jenis", label: "Jenis Overhead", type: "select", options: [
          { value: "listrik", label: "Listrik" }, { value: "bbm", label: "BBM" }, { value: "air", label: "Air" },
          { value: "penyusutan", label: "Penyusutan" }, { value: "pemeliharaan", label: "Pemeliharaan" }, { value: "qc", label: "QC/Laboratorium" },
        ] },
        { key: "satuan", label: "Satuan" },
        { key: "tarif", label: "Tarif (Rp)", type: "number" },
        { key: "keterangan", label: "Keterangan", type: "textarea", full: true },
      ]}
    />
  );
}
